<template>
  <div>
    <div class="menu" id="menu">
      <div class="content1">
        <div class="btn">
          <ul>
            <li class="black">
              <router-link to="/">Home</router-link>
            </li>
            <li class="ww">|</li>
            <li>
              <router-link to="/blastcenter">Blast</router-link>
            </li>
            <li class="ww">|</li>
            <li>
              <router-link to="/primer">Primer design</router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- <div class="line"></div> -->
    <div class="main">
      <div class="content">
        <div class="banner">
          <div class="title">
            <div class="bg">Database Introduction</div>
            <div class="line2"></div>
          </div>
          <div class="ms">
            <p>
              1K Medicinal Plant Genome Research Project aims to complete the
              collection and sequencing of 1000 important medicinal plant
              genomes within 3-5 years, and builds the world's largest database
              of medicinal plant genomes. The database collects genomic data and
              related information of related medicinal plants, aiming to promote
              the research of genomics, secondary metabolite synthesis biology
              and related molecular breeding of medicinal plants.
            </p>
            <p>千种药用植物基因组研究计划旨在3-5年内收集整理并测序完成1000种重要的药用植物基因组，并构建一个全球最大的药用植物基因组数据库。该数据库汇集相关药用植物的基因组数据及其相关信息，旨在推动药用植物基因组学、次生代谢产物合成生物学及相关分子育种的研究。</p>
          </div>
        </div>
        <!-- <div class="des">
          <h3>药用植物基因组数据库简介</h3>
          <p>
            基因组是所有物种及性状的决定基础，是当代生物学研究的关键。高通量测序技术的快速发展推动了基因组学研究的发展。千种药用植物基因组数据库汇集中药相关物种的基因组数据及其相关信息，旨在推动药用植物基因组学研究及药用植物合成生物学及分子育种的相关研究。
          </p>
          <p>
            Genome is the basis of determining all species and traits, and is
            the highlight of contemporary biology research. The rapid
            development of high throughput sequencing technology has promoted
            the research of genomics. The genome database of thousands of
            medicinal plants collects the genome data and related information of
            medicinal plants, aiming to promote the research on the genomics of
            medicinal plants and the research on the synthetic biology and
            molecular breeding of medicinal plants.
          </p>
        </div>-->
        <div class="search">
          <!-- <div class="font">Genome Search</div> -->
          <div class="search_cont">
            <el-input
              placeholder="search by species name..."
              v-model="indexSearchInput"
              class="input-with-select"
            >
              <!-- <button class="mysearch"  @click="indexSearch"> Search </button> -->
              <el-button @click="indexSearch" class="mysearch" slot="append">Search</el-button>
            </el-input>
          </div>
        </div>
        <div class="table">
          <table cellpadding="0" cellspacing="0" border="1">
            <tr>
              <!--<th>英文名</th>-->
              <th class="minwidth">Medicinal plants</th>
              <th>Species</th>
              <th class="minwidth">Family</th>
              <th class="minwidth">Genus</th>
              <th>Officinal parts</th>
              <th>Natural product</th>
              <th class="minwidth">Thumbnail</th>
            </tr>
            <tr v-for="(item, index) in tableData" :key="index">
              <!--<td :class="item.englishName == '-' ? '' : 'textleft'" v-html="item.englishName"></td>-->
              <td>
                <router-link
                  :to="{
                    path: '/species',
                    query: {
                      id: item.id,
                      did: item.did,
                      latin_name: item.latinName,
                      plant_name: item.plantName,
                      cover_url: item.thumbnail,
                      page,
                      num,
                      pagenews,
                      numnews
                    }
                  }"
                >
                  <a>{{ item.plantName }}</a>
                </router-link>
              </td>
              <td class="textleft" v-html="item.latinName"></td>
              <td>
                <router-link
                  :to="{
                    path: '/family',
                    query: { familyId: item.familyId },
                  }"
                >{{ item.family }}</router-link>
              </td>
              <!-- <td v-html="item.genus"></td> -->
              <td>
                <router-link
                  :to="{
                    path: '/genus',
                    query: { genusId: item.genusId },
                  }"
                >{{ item.genus }}</router-link>
              </td>
              <td v-html="item.medLocation"></td>
              <td v-html="item.medIngredients"></td>

              <td>
                <el-popover placement="right" width="150" trigger="hover">
                  <img :src="item.thumbnail" style="height: 150px; width: 150px" />
                  <img
                    slot="reference"
                    :src="item.thumbnail"
                    style="height: 50px; width: 50px; margin-top: 10px"
                  />
                </el-popover>
              </td>
            </tr>
            <tr v-if="tableData.length < 1">
              <td colspan="9">暂无数据</td>
            </tr>
          </table>
          <!-- <el-table
            :header-cell-style="{
              background: 'seagreen',
              color: '#fff',
              height: '35px',
              padding: '6px 0',
              textAlign: 'center',
            }"
            :data="tableData"
            border
            style="width: 100%"
          >
            <el-table-column align="center" label="中药名">
              <template slot-scope="scope">
                {{ scope.row.traChiMed }}
              </template>
            </el-table-column>

            <el-table-column prop="englishName" label="英文名">
            </el-table-column>
            <el-table-column align="center" label="植物名称">
              <template slot-scope="scope">
                <router-link
                  :to="{
                    path: '/species',
                    query: {
                      id: scope.row.id,
                      did: scope.row.did,
                      latin_name: scope.row.latinName,
                      plant_name: scope.row.plantName,
                    },
                  }"
                  ><a>{{ scope.row.plantName }}</a></router-link
                >
              </template>
            </el-table-column>
            <el-table-column label="拉丁名">
              <template slot-scope="scope">
                <span v-html="scope.row.latinName"></span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="科名">
              <template slot-scope="scope">
                <router-link
                  :to="{
                    path: '/family',
                    query: { familyId: scope.row.familyId },
                  }"
                >
                  {{ scope.row.family }}
                </router-link>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="genus" label="属名">
              <template slot-scope="scope">
                <router-link
                  :to="{
                    path: '/genus',
                    query: { genusId: scope.row.genusId },
                  }"
                >
                  {{ scope.row.genus }}
                </router-link>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="medLocation" label="药用部位">
            </el-table-column>
            <el-table-column align="center" label="药用化学成分">
              <template slot-scope="scope">
                {{ scope.row.medIngredients }}
              </template>
            </el-table-column>
            <el-table-column align="center" label="缩略图">
              <template slot-scope="scope">
                <el-popover placement="right" width="150" trigger="hover">
                  <img
                    :src="scope.row.thumbnail"
                    style="height: 150px; width: 150px"
                  />
                  <img
                    @mouseover="thumbnailover(scope)"
                    slot="reference"
                    :src="scope.row.thumbnail"
                    style="height: 50px; width: 50px"
                  />
                </el-popover>
              </template>
            </el-table-column>
          </el-table>-->
          <el-pagination
            class="pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="num"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
          <br />
        </div>

        <div class="news">
          <div class="news_cont">
            <div class="font">News & Updates</div>
            <ul>
              <li v-for="(item,index) in newsList" :key="index">
                <div class="title">
                  <router-link :to="{path:'/news',query: {newsid: item.id,pagenews, numnews,page,num }}">
                    {{item.title}}
                    <img src="../../assets/hot.png" width="15" height="15" />
                  </router-link>
                </div>
                <div class="date">{{item.time}}</div>
              </li>
              <!-- <li>
                <div class="title">
                  <router-link to="/news1"
                    >千种药用植物基因组数据库上线通知
                    <img src="../../assets/hot.png" width="15" height="15" />
                  </router-link>
                </div>
                <div class="date">2020-05-15 09:52</div>
              </li>
              <li>
                <div class="title">
                  <router-link to="/news2"
                    >文献解读：雷公藤基因组及其活性成分雷公藤甲素生物合成</router-link
                  >
                </div>
                <div class="date">2020-05-15 09:52</div>
              </li>
              <li>
                <div class="title">
                  <router-link to="/news3"
                    >文献解读：金银花基因组揭示动态花色中类胡萝卜素代谢的分子机制</router-link
                  >
                </div>
                <div class="date">2020-05-15 09:52</div>
              </li>-->
            </ul>
            <el-pagination
              class="newspagination"
              @size-change="handleSizeChangenews"
              @current-change="handleCurrentChangenews"
              :current-page="pagenews"
              :page-sizes="[5, 10]"
              :page-size="numnews"
              layout="total, sizes, prev, pager, next, jumper"
              :total="newstotal"
            ></el-pagination>
          </div>
        </div>

        <div class="link">
          <div class="link_cont">
            <div class="font">Partners</div>
            <ul>
              <li v-for="(item,index) in linkList" :key="index">
                <a :href="item.link" v-html="item.name"></a>
              </li>
              <li v-if="linkList.length<1">
                <a href="#">no data</a>
              </li>
              <!-- <li><a href="https://www.chp.org.cn/">国家药典委员会</a></li>
              <li><a href="http://www.cacm.org.cn/">中华中医药学会</a></li>
              <li>
                <a
                  href="https://library.hkbu.edu.hk/electronic/libdbs/mpd/index.html"
                  >药用植物图像数据库</a
                >
              </li>
              <li><a href="http://www.ndctcm.org/">中国中药数据中心</a></li>
              <li><a href="http://www.benagen.com/">贝纳基因</a></li>-->
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios"
import Species from "./Species.vue"
import trackEvent from "@/utils/baiduAnalytics"
export default {
  components: { Species },
  data() {
    return {
      visible: false,
      activeIndex: "1",
      activeIndex2: "1",
      currentPage4: 4,
      tableData: [
        // {
        //   chinese_name: "人参",
        //   english_name: "GINSENG RADIX ET RHIZOMA",
        //   plant_name: "人参",
        //   latin_name: "Panax ginseng C. A. Mey.",
        //   family: "五加科",
        //   genus: "人参属",
        //   med_location: "干燥根和根茎",
        //   med_ingredients: "人参皂苷等（详情点击）",
        //   thumbnail: "https://www.baidu.com/img/flexible/logo/pc/result.png",
        // },
      ],
      indexSearchInput: "",
      total: 0,
      num: 10,
      page: 1,
      linkList: [],
      newstotal: 0,
      newsList: [],
      numnews: 5,
      pagenews: 1,
    }
  },
  created() {
     let type = this.$route.query.type
      if (type) {
           this.pagenews = parseInt(this.$route.query.pagenews?this.$route.query.pagenews:1)
           this.numnews = parseInt(this.$route.query.numnews?this.$route.query.numnews:5)
           this.page = parseInt(this.$route.query.page? this.$route.query.page:1)
           this.num = parseInt(this.$route.query.num?this.$route.query.num:10)
      }

    this.getall(this.num, this.page)
    this.getlink()
    this.getnews(this.numnews, this.pagenews)
    window.addEventListener("scroll", this.handleScroll)
  },
  methods: {
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      let offsetTop = document.querySelector("#menu").offsetTop
      let isFixed = scrollTop > offsetTop ? true : false
      if (isFixed) {
        document.querySelector("#menu").style =
          "position: fixed;top:0;background:#fff;z-index:9999"
      } else {
        document.querySelector("#menu").style = ""
      }
    },
    indexSearch() {
      trackEvent.call(this, '首页的搜索按钮', '点击')
      ////console.log(this.indexSearchInput);
      if (this.indexSearchInput == "" || this.indexSearchInput == null) {
        // this.$alert("请输入物种植物名或拉丁名或中药名进行搜索！", "Notice", {
        //   confirmButtonText: 'Confirm',
        //   callback: (action) => {},
        // });
        this.getall(this.num, this.page)
      } else {
        let indexSearchInput = this.indexSearchInput
        if (indexSearchInput.indexOf("属") == indexSearchInput.length - 1) {
          ////console.log("属");
          this.searchFamily(indexSearchInput, "属")
        } else if (
          indexSearchInput.indexOf("科") ==
          indexSearchInput.length - 1
        ) {
          ////console.log("科");
          this.searchFamily(indexSearchInput, "科")
        } else {
          ////console.log('物种');
          this.searchPlant(indexSearchInput)
        }
      }
    },
    searchFamily(indexSearchInput, str) {
      let that = this
      let token = localStorage.getItem("authorization")
      if (token == "" || token == null) {
        this.$alert("Login expired, please log in again", "Notice", {
          confirmButtonText: 'Confirm',
          callback: (action) => {
            that.$router.push("/login")
          },
        })
        return false
      }
      axios
        .get("/bena/server/genus/id?name=" + indexSearchInput, {
          headers: { Authorization: token },
        })
        .then(function (response) {
          //console.log(response);
          if (response.data.code == 0) {
            //that.tableData = response.data.result;
            if (response.data.result) {
              if (str == "科") {
                ///family?familyId=1
                that.$router.push("/family?familyId=" + response.data.result)
              }
              if (str == "属") {
                that.$router.push("/genus?genusId=" + response.data.result)
              }
            } else {
              that.$alert("Sorry, no results were found！", "Notice", {
                confirmButtonText: 'Confirm',
                callback: (action) => { },
              })
            }
          } else {
            that.$alert("Loading failed！" + response.data.msg, "Notice", {
              confirmButtonText: 'Confirm',
              callback: (action) => { },
            })
          }
        })
        .catch(function (error) {
          that.$alert("Loading failed！" + error.response.data.message, "Notice", {
            confirmButtonText: 'Confirm',
            callback: (action) => { },
          })
          //that.$message.error("失败!");
          //console.log(error);
        })
    },
    searchPlant(plant) {
      let that = this
      let token = localStorage.getItem("authorization")
      if (token == "" || token == null) {
        this.$alert("Please login first!", "Notice", {
          confirmButtonText: "Confirm",
          callback: (action) => {
            //that.$router.push("/login");
          },
        })
        return false
      }
      axios
        .get("/bena/server/gooal/genome/search?name=" + plant, {
          headers: { Authorization: token },
        })
        .then(function (response) {
          //console.log(response);
          if (response.data.code == 0) {
            //that.tableData = response.data.result;
            if (response.data.result.length > 0) {
              that.tableData = response.data.result
              that.total = response.data.result.length
              // if (response.data.result[0].did) {
              //   that.$router.push(
              //     "/species?did=" +
              //       response.data.result[0].did +
              //       "&latin_name=" +
              //       response.data.result[0].latinName +
              //       "&plant_name=" +
              //       response.data.result[0].plantName +
              //       "&id=" +
              //       response.data.result[0].id
              //   );
              // }
            } else {
              that.$alert("Sorry, no results were found！", "Notice", {
                confirmButtonText: 'Confirm',
                callback: (action) => { },
              })
            }
          } else {
            that.$alert("Loading failed！" + response.data.msg, "Notice", {
              confirmButtonText: 'Confirm',
              callback: (action) => { },
            })
          }
        })
        .catch(function (error) {
          that.$alert("Loading failed！" + error.response.data.message, "Notice", {
            confirmButtonText: 'Confirm',
            callback: (action) => { },
          })
          //console.log(error.response);
        })
    },
    getlink() {
      let that = this
      let token = localStorage.getItem("authorization")
      //console.log(token);
      axios
        .get("/bena/server/link/get", {
          headers: { Authorization: token },
        })
        .then(function (response) {
          //console.log(response);
          if (response.data.code == 0) {
            that.linkList = response.data.result
          } else {
            that.$alert("Loading failed！" + response.data.msg, "Notice", {
              confirmButtonText: 'Confirm',
              callback: (action) => { },
            })
          }
        })
        .catch(function (error) {
          //console.log(error.response);
          that.$alert("Loading failed！" + error.response.data.message, "Notice", {
            confirmButtonText: 'Confirm',
            callback: (action) => { },
          })
        })
    },
    getnews(num, page) {
      let that = this
      let token = localStorage.getItem("authorization")
      //console.log(token);
      axios
        .get("/bena/server/news/get?size=" + num + "&page=" + page, {
          headers: { Authorization: token },
        })
        .then(function (response) {
          //console.log(response);
          if (response.data.code == 0) {
            that.newsList = response.data.result.list
            that.newstotal = response.data.result.total
          } else {
            that.$alert("Loading failed！" + response.data.msg, "Notice", {
              confirmButtonText: 'Confirm',
              callback: (action) => { },
            })
          }
        })
        .catch(function (error) {
          //console.log(error.response);
          that.$alert("Loading failed！" + error.response.data.message, "Notice", {
            confirmButtonText: 'Confirm',
            callback: (action) => { },
          })
        })
    },
    getall(num, page) {
      let that = this
      let token = localStorage.getItem("authorization")
      //console.log(typeof token);
      axios
        .get("/bena/server/gooal/genome/getlist?num=" + num + "&page=" + page, {
          headers: { Authorization: token },
        })
        .then(function (response) {
          //console.log(response);
          if (response.data.code == 0) {
            that.tableData = response.data.result.list
            that.total = response.data.result.total
          } else {
            that.$alert("Loading failed！" + response.data.msg, "Notice", {
              confirmButtonText: 'Confirm',
              callback: (action) => { },
            })
          }
        })
        .catch(function (error) {
          //console.log(error.response);
          that.$alert("Loading failed！" + error.response.data.message, "Notice", {
            confirmButtonText: 'Confirm',
            callback: (action) => {
              localStorage.clear()
              that.$router.push("/login")
              if (error.response.data.message == 'The information for the current login cannot be found') {
                localStorage.clear()
                that.$router.push("/login")
              }
            },
          })
        })
    },
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.num = val
      this.getall(this.num, this.page)
    },
    handleSizeChangenews(val) {
      //console.log(`每页 ${val} 条`);
      this.numnews = val
      this.getnews(this.numnews, this.pagenews)
    },
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.page = val
      this.getall(this.num, this.page)
    },
    handleCurrentChangenews(val) {
      //console.log(`当前页: ${val}`);
      this.pagenews = val
      this.getnews(this.numnews, this.pagenews)
    },
    thumbnailover(scope) {
      //console.log(scope.row.thumbnail);
    },
  },
};
</script>
<style scoped>
.menu {
  width: 100%;
  height: 60px;
  flex: 0;
  border-bottom: 1px solid #ccc;
  margin-bottom: 10px;
  box-shadow: 1px 1px 2px #ccc;
}
.menu .content1 {
  width: 1200px;
  height: 50px;
  margin: 0 auto;
  /* border: 1px solid red; */
}
.menu .black {
  color: #000;
}
.menu .content1 .logo {
  float: left;
  width: 250px;
  height: 50px;
  margin: 5px 0;
  /* border: 1px solid #ccc; */
  line-height: 50px;

  text-align: center;
}
.menu .content1 .logo a {
  text-decoration: none;
  font-size: 20px;
  color: seagreen;
  font-weight: bold;
}
.menu .content1 .btn {
  /* float: right; */
  width: auto;
}
.menu .content1 .btn ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.menu .content1 .btn ul li {
  float: left;
  padding: 0 20px;
  line-height: 50px;
}
.menu .content1 .btn ul li.ww {
  color: #ccc;
}
.menu .content1 .btn ul li a {
  text-decoration: none;
  color: #333;
  font-size: 14px;
}
.menu .content1 .btn ul li:nth-child(1) a {
  color: #000;
  font-weight: 700;
}
.menu .content1 .btn .el-menu.el-menu--horizontal {
  border: none;
}
.line {
  width: 100%;
  height: 10px;
  background: #eee;
  flex: 0;
}
.banner {
  width: 1200px;
  height: 400px;
  background: url(../../assets/banner.png);
}
.banner .title {
  float: left;
  width: 450px;
  height: 400px;
  /* border: 1px solid red; */
}
.banner .title div.bg {
  background: seagreen;
  width: 300px;
  height: 45px;
  text-align: center;
  line-height: 45px;
  color: #fff;
  font-size: 20px;
  margin: 120px auto 0 auto;
}
.banner .title div.line2 {
  width: 300px;
  height: 2px;
  background: #fff;
  margin: 15px auto 0 auto;
}
.banner .ms {
  float: right;
  width: 520px;
  height: 320px;
  /* border: 1px solid red; */
  margin-right: 80px;
  background: rgba(46, 139, 87, 0.6);
  padding: 40px;
  color: #fff;
  line-height: 25px;
  font-size: 14px;
}
.el-table__header-wrapper .el-table__header .has-gutter tr th {
  text-align: center;
}
.pagination.el-pagination >>> li.number.active {
  color: seagreen;
}
.pagination.el-pagination >>> .el-input__inner:hover {
  border: 1px solid seagreen;
}
.el-select-dropdown__item.selected span {
  color: seagreen;
}
.pagination.el-pagination >>> li.number:hover {
  color: seagreen;
}
.input-with-select.el-input.el-input-group.el-input-group--append
  >>> .el-input__inner {
  border: 1px solid seagreen;
  height: 37px;
  font-size: 12px;
  border-radius: 15px 0px 0px 15px;
  margin-top: 0px;
}
.input-with-select.el-input >>> .el-input-group__append,
.el-input-group__prepend {
  border: none;
  background: none;
}
.el-button.el-button--default.mysearch {
  background: seagreen;
  color: #fff;
  width: 100px;
  border: none;
  border-radius: 0px 15px 15px 0px;
}
.main {
  width: 100%;
  height: auto;
}
.main .content {
  width: 1200px;
  margin: 0 auto;
  height: auto;
  /* border: 1px solid #ccc; */
  /* padding: 10px 0; */
}
.main .content .des {
  background: #eee;
  padding: 10px 20px;
}
.main .content .des p {
  line-height: 30px;
  font-size: 14px;
  text-indent: 30px;
}
.search {
  /* margin-top: 15px; */
  padding: 0 0px 10px 0px;
  /* border: 1px solid red; */
}
.search .font {
  line-height: 30px;
  padding: 0 0 0 10px;
}
.search_cont {
  width: 900px;
  height: 40px;
  background: #e3f3ea;
  padding: 20px 150px;
}
.main .table {
  width: 100%;
  height: auto;
  /* border: 1px solid red; */
  margin-top: 15px;
  background: #fff;
  box-shadow: 0 0 5px #ccc;
}
.main .table a {
  text-decoration: none;
  color: seagreen;
}
.newspagination {
  text-align: right;
  margin: 15px 15px 5px 0;
}
.main .table .pagination {
  text-align: right;
  margin: 15px 15px 5px 0;
}
.table table {
  width: 100%;
  border-collapse: collapse;
}
.table table tr:first-child {
  background: seagreen;
  color: #fff;
}
.table table tr,
td,
th {
  border: 1px solid #ccc;
  text-align: center;
  line-height: 35px;
  font-size: 13px;
}
.table table td.textleft,
th.textleft {
  text-align: left;
  padding-left: 15px;
}
.table table td.minwidth,
th.minwidth {
  min-width: 80px;
}
.news {
  margin-top: 15px;
  padding: 0 0px 10px 0px;
  /* border: 1px solid red; */
}
.news .font {
  line-height: 35px;
  padding: 0 0 0 10px;
  background: seagreen;
  width: 120px;
  text-align: center;
  color: #fff;
  border-radius: 0 0px 15px 15px;
  margin-left: 20px;
}
.news_cont {
  width: 100%;
  height: auto;
  background: #fff;
  box-shadow: 0px 0px 12px #ccc;
  padding-bottom: 10px;
}
.news_cont .font{
  width: 180px;
}
.news_cont ul {
  margin: 10px 0;
  padding: 0;
  list-style: none;
}
.news_cont ul li {
  line-height: 30px;
  width: 100%;
  height: 30px;
  cursor: pointer;
  font-size: 14px;
}
.news_cont ul li a {
  text-decoration: none;
  color: #333;
}
.news_cont ul li:hover a {
  color: seagreen;
  font-weight: 700;
  /* font-size: 15px; */
}
.news_cont ul li .title {
  float: left;
  margin-left: 20px;
}
.news_cont ul li .date {
  float: right;
  margin-right: 30px;
}

.link {
  margin-top: 15px;
  padding: 0 0px 10px 0px;
  /* border: 1px solid red; */
}
.link .font {
  line-height: 35px;
  padding: 0 0 0 10px;
  background: seagreen;
  width: 120px;
  text-align: center;
  color: #fff;
  border-radius: 0 0px 15px 15px;
  margin-left: 20px;
}
.link_cont {
  width: 100%;
  height: auto;
  overflow: auto;
  background: #fff;
  box-shadow: 0px 0px 12px #ccc;
  padding-bottom: 20px;
}
.link_cont ul {
  list-style: none;
  margin: 10px;
  padding: 0;
}
.link_cont ul li {
  padding: 10px 20px;
  float: left;
}
.link_cont ul li a {
  text-decoration: none;
  font-size: 14px;
  color: seagreen;
}
.link_cont ul li:hover a {
  font-size: 15px;
  color: seagreen;
  font-weight: bold;
}
</style>
